// extracted by mini-css-extract-plugin
module.exports = {"ActionBar":"MccApproverPendingLoan_ActionBar__23CF_","AggregatorSearch":"MccApproverPendingLoan_AggregatorSearch__1Xirf"};